import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { GtmRepository } from '../repositories/gtm.repository';

export class GtmSelectCartUseCase implements UseCase<never, boolean> {
    constructor(private readonly repository: GtmRepository) {}

    execute(): Observable<boolean> {
        return this.repository.selectCart();
    }
}
